
import * as React from 'react';
import PropTypes from 'prop-types';
import Item  from './item';

export default function List({ requirements, onDelete }) {
  const renderList = () => {
    return (
      <div>
        {
          requirements.map((req, index) => (
            <div key={req.id + 'requirement'}>
              {index > 0 && <hr className="mt-3 mb-4"/>}
              <Item requirement={req} onDelete={onDelete} />
            </div>
          ))
        }
      </div>
    );
  };

  const renderEmptyState = () => (
    <div className="mt-2 text-muted">This is where you can view the contact's requirements</div>
  );

  return (
    <>
      {requirements.length > 0 ? renderList() : renderEmptyState()}
    </>
  );
}

List.propTypes = {
  requirements: PropTypes.arrayOf(PropTypes.shape({
    buildingSize: PropTypes.string,
    id: PropTypes.number.isRequired,
    leaseDate: PropTypes.string,
    lotSize: PropTypes.string,
    name: PropTypes.string.isRequired,
    notes: PropTypes.string,
    numberOfUnits: PropTypes.string,
    propertyTypes: PropTypes.string,
    salePrice: PropTypes.string,
    searchPath: PropTypes.string.isRequired,
    transactionType: PropTypes.string.isRequired
  })).isRequired,
  onDelete: PropTypes.func.isRequired
};
